<template>
   <vs-popup id="popup-add-article" class="popup-add-article" title="Add Article" :active.sync="popupAddArticle.isOpen">
    <vs-input label="Title" placeholder="" v-model="title" class="w-full mb-4"/>

    <label class="vs-input--label">Body</label>
    <vue-editor v-model="content" class="mb-4"></vue-editor>

    <label class="vs-input--label">Thumbnail</label>
    <image-article :image="image"></image-article>

    <div class="flex" style="justify-content: flex-end">
      <vs-button @click="submitData()">Save</vs-button>
    </div>
   </vs-popup>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: 'add-article',
  components:{
    VueEditor
  },
  props: {
    popupAddArticle:{
      type: Object,
      required: true
    }
  },
  data(){
    return {
      image: '',
      title: '',
      content: '',
    }
  },
  methods:{
    submitData(){
      console.log(this.content)
    }
  }
}
</script>
